import * as React from "react";
import './Pick.css';
import '../../components/Typograph.css';
import AppHeader from '../../components/AppHeader';
import AppFooter from "../../components/AppFooter";
import ImageRadioPicker from "../../components/ImageRadioPicker";
import {Luiksluiting, Luikvastzetter} from "../../Model";
import geenLuikvastzetterImage from '../../images/luikvastzetter/geen luikvastzetter.jpg'
import herderinnekopjeImage from '../../images/luikvastzetter/herderinnekopje.jpg'
import hollandseLuikwervelImage from '../../images/luikvastzetter/hollandse.jpg'
import luikwervelMarseilleImage from '../../images/luikvastzetter/luikwervelMarseille.jpg'
import komfortLuikvastzetterImage from '../../images/luikvastzetter/komfortvastzetter Maco rustico onder het luik.jpg'
import verborgenLuikvastzetterImage from '../../images/luikvastzetter/verborgen luikvastzetter model F.jpg'
import verborgenLuikvastzetterMacoImage from '../../images/luikvastzetter/luikvastzetterMaco.jpg'
import automatischeLuikvastzetterZwartImage from '../../images/luikvastzetter/automatisch.jpg'
import comfortSluitingImage from '../../images/luikvastzetter/macoRusticoComfortsluiting.jpg'
import otherImage from "../../images/template/other1.png";
import PropTypes from "prop-types";

FastenerPick.propTypes = {
    handleNextPage: PropTypes.func.isRequired,
    handlePreviousPage: PropTypes.func.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    allValues: PropTypes.object.isRequired,
}

const compatibilityClosings = [
    Luiksluiting.TYPE_A
]

const compatibilityFastener = [
    Luikvastzetter.VERBORGEN_LUIKVASTZETTER_MACO,
    Luikvastzetter.AUTOMATISCHE_LUIKVASTZETTER_ZWART,
    Luikvastzetter.COMFORT_SLUITING,
]

export default function FastenerPick(props) {
    const currentValue = props.allValues.FastenerPick;
    const closingValue = props.allValues.ClosingPick;

    const createErrorsOnMismatch = () => {
        if (!currentValue) return undefined;
        if (compatibilityClosings.includes(closingValue) && compatibilityFastener.includes(currentValue)) {
            return (
                <p className="detail-warning-text">
                    De eerder gekozen luiksluiting '{closingValue}' kan niet worden gecombineerd met de
                    luikvastzetter '{currentValue}'.
                </p>
            )
        }
        return null;
    }

    return (
        <div className="page">
            <AppHeader title="Luikvastzetter"/>

            <div className="page-middle">
                <h1 className="pick-title">Welke luikvastzetter moet deze situatie krijgen?</h1>
                <h4>Het is mogelijk dat uw voorkeur niet altijd te combineren is met uw aanvraag. In dat geval zullen wij u een passend alternatief advies geven.</h4>
                <div className="pick-body scrollable">
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luikvastzetter.HERDERINNEKOPJE}
                                      image={herderinnekopjeImage}
                                      hintText={"herderinnekopje is alleen aan de onderkant van het luik te plaatsen"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luikvastzetter.HOLLANDSE_LUIKWERVEL}
                                      image={hollandseLuikwervelImage}
                                      hintText={"hollandse luikwervel is alleen aan de onderkant van het luik te plaatsen"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luikvastzetter.LUIKWERVEL_MARSEILLE}
                                      image={luikwervelMarseilleImage}
                                      hintText={"luikvastzetter Marseille is aan de onderkant en aan de zijkant van het luik te plaatsen"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luikvastzetter.VERBORGEN_LUIKVASTZETTER_MACO}
                                      image={verborgenLuikvastzetterMacoImage}
                                      hintText={"verborgen luikvastzetter kan aan de (achter) zijkant geplaatst worden"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luikvastzetter.VERBORGEN_LUIKVASTZETTER}
                                      image={verborgenLuikvastzetterImage}
                                      hintText={"verborgen luikvastzetter model F, kan aan de achter- of zijkant worden geplaatst"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luikvastzetter.AUTOMATISCHE_LUIKVASTZETTER_ZWART}
                                      image={automatischeLuikvastzetterZwartImage}
                                      hintText={"automatische luikvastzetter is alleen aan de onderkant van het luik te plaatsen"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luikvastzetter.COMFORT_SLUITING}
                                      image={comfortSluitingImage}
                                      hintText={"Maco Rustico Comfort vastzetter: achterzijde montage, binnenbediening voor verdiepingsluiken, alleen bij binnendraaiende ramen"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luikvastzetter.COMFORT_ONDER_LUIKVASTZETTER}
                                      image={komfortLuikvastzetterImage}
                                      hintText={"Maco Rustico Comfort vastzetter: montage onder het luik, binnenbediening voor verdiepingsluiken, alleen bij binnendraaiende ramen"}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={Luikvastzetter.NO_FASTENER}
                                      image={geenLuikvastzetterImage}/>
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={{value: Luikvastzetter.OTHER, text: ""}}
                                      child
                                      image={otherImage}/>
                </div>
                {createErrorsOnMismatch()}
            </div>
            <AppFooter onNext={props.handleNextPage}
                       onPrevious={props.handlePreviousPage}
                       enableNext={createErrorsOnMismatch() === null}/>
        </div>
    );
}
